<template>
  <div>
    <vue-headful title="Matches" />
    <Header page_title="Matches" />
    <div v-if="results ? results.data && results.data.length > 0 : false" class="">
      <div class="container-fluid app-body mt-0">
        <div class="clearfix mb-3">
          <p class="float-right mb-4">
            <strong>{{ results.data.length }}</strong> matches
          </p>
          <button
            hidden
            type="button"
            class="btn-filter position-relative p-0 m-0 float-right"
          >
            Filter
            <div class="icon-wrapper d-inline-block">
              <i class="material-icons-round">filter_list</i>
            </div>
          </button>
        </div>
        <div class="mb-4 applicant-overview" v-if="branch != 3">
          <ApplicantCard
            v-for="(match, index) in results.data"
            :key="index"
            :index_key="index"
            :applicant="match"
            :view="true"
            :matchOverview="false"
            @notification="notifChanged"
            @match-id-change="matchIdChanged"
          />
          <Pagination :results="results" :api="api" @page-change="pageChanged" />
        </div>
        <div class="mb-4 applicant-overview" v-if="branch == 3">
          <HealthcareApplicantCard
              v-for="(match, index) in results.data"
              :key="index"
              :applicant="match"
              :view="true"
          />
          <Pagination :results="results" :api="api" @page-change="pageChanged" />
        </div>
      </div>
    </div>
    <Empty v-else text="Je hebt geen overeenkomsten voor deze baan." />
    <div
      v-if="fullscreen_notif == 'comment'"
      class="fullscreen-notif match position-fixed"
    >
      <button
        type="button"
        class="close position-fixed"
        aria-label="Close"
        v-on:click="fullscreen_notif = null; match_id = null; match_key =  null; comment = ''"
      >
        <div class="icon-wrapper">
          <i class="material-icons-round">close</i>
        </div>
      </button>
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div>
              <NotificationContainer />
              <div class="form-group">
                <textarea
                  maxlength="160"
                  class="form-control mb-2"
                  :placeholder="
                    'Heb je vragen of opmerkingen over deze vacature? \n(Max. 160 tekens)'
                  "
                  rows="4"
                  spellcheck="false"
                  v-model="comment"
                ></textarea>
              </div>
              <a
                class="btn btn-warning btn-block"
                role="button"
                @click="onInterested"
                >Doorgaan</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import ApplicantCard from "@/components/ApplicantCard.vue";
import HealthcareApplicantCard from "@/components/HealthcareApplicantCard.vue";

export default {
  data: function() {
    return {
      branch: localStorage.getItem("branch"),
      results: null,
      api: null,
      fullscreen_notif: null,
      match_id: null,
      match_key: null,
      comment: ""
    };
  },
  props: ["id"],
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.api = "job/" + parseInt(this.id) + "/matches";
      this.results = await this.getListwithPages(this.api);

      this.$store.state.loading = false;
    },
    async pageChanged(data) {
      this.results = await this.getListwithPages(data);
    },
    async notifChanged () {
      this.fullscreen_notif = "comment"
    },
    async matchIdChanged (id, index_key) {
      this.match_id = id;
      this.match_key = index_key;
    },
    async onInterested() {
      return new Promise((resolve, reject) => {
        this.$store.state.loading = true;

        var url = this.$apiURI + "/interest";
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        let formData = new FormData();
        formData.append("match_id", parseInt(this.match_id));
        formData.append("comment", this.comment);
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            this.$store.state.loading = false;
            this.results.data[this.match_key].is_interested = 1;
            this.match_id = null;
            this.match_key = null;
            this.comment = "";
            this.fullscreen_notif = null;
            if (typeof dataLayer !== "undefined") {
              dataLayer.push({
                event: "SchoolTeacherInterest",
                eventCategory: "School",
                eventAction: "School – Teacher interest",
                eventLabel: "",
                eventValue: "1"
              });
            }
            resolve();
          })
          .catch(error => {
            console.log(error);
            this.$store.state.loading = false;
            this.match_id = null;
            this.match_key = null;
            this.comment = "";
            this.fullscreen_notif = null;
            reject();
          });
      });
    }
  },
  components: {
    HealthcareApplicantCard,
    ApplicantCard
  }
};
</script>

<style scoped>
::v-deep .applicant-link .text.position {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 20px;
}
</style>
